import initMenu from "./components/menu.js";
import initStage from "./components/stage.js";
import initSectionLogos from "./components/section-logos.js";

document.documentElement.classList.remove("no-js");
document.documentElement.classList.add("js");

initMenu();
initStage();
initSectionLogos();
